import { InjectionToken } from "@angular/core";

export let APP_CONFIG = new InjectionToken<AppConfig>("app.config");


export interface AppConfig {
	availableLanguages: Array<{ code: string, name: string }>;
	expertise: Array<{ title: string }>;
	showBuyPromt: boolean;
	instantAppoiintmentFilters: Array<{ key: string, value: string }>;
}



export const BaseAppConfig: AppConfig = {
	availableLanguages: [{
		code: 'en',
		name: 'English'
	}, {
		code: 'ar',
		name: 'Arabic'
	}, {
		code: 'tr',
		name: 'Türkçe'
	}
	],
	showBuyPromt: false,
	instantAppoiintmentFilters: [{
		key: 'pending',
		value: 'pending_expert_confirmation'
	}, {
		key: 'rejected',
		value: 'rejected_by_expert'
	}, {
		key: 'confirmed',
		value: 'confirmed_by_expert'
	}, {
		key: 'cancelled',
		value: 'cancelled_by_patient'
	}, {
		key: 'not_come',
		value: 'didnt_connect_to_conversation'
	}
	],
	expertise: [

		{ title: "internal_diseases"},
		{ title: "cardiology"},
		{ title: "chest_diseases"},
		{ title: "infectious_diseases"},
		{ title: "neurology"},
		{ title: "psychiatry"},
		{ title: "child_health_and_diseases"},
		{ title: "child_psychiatry"},
		{ title: "dermatology"},
		{ title: "physical_medicine_and_rehabilitation"},
		{ title: "general_surgery"},
		{ title: "pediatric_surgery"},
		{ title: "thoracic_surgery"},
		{ title: "cardiac_surgery"},
		{ title: "neurosurgery"},
		{ title: "plastic_reconstructive_and_aesthetic_surgery"},
		{ title: "orthopedics_and_traumatology"},
		{ title: "urology"},
		{ title: "ear_nose_throat_diseases"},
		{ title: "eye_diseases"},
		{ title: "gynecology_and_obstetrics"},
		{ title: "anesthesiology_and_reanimation"},
		{ title: "radiation_oncology"},
		{ title: "radiology"},
		{ title: "nuclear_medicine"},
		{ title: "medical_pathology"},
		{ title: "medical_genetics"},
		{ title: "medical_biochemistry"},
		{ title: "medical_microbiology"},
		{ title: "medical_pharmacology"},
		{ title: "sports_medicine"},
		{ title: "military_field_medicine"},
		{ title: "aerospace_medicine"},
		{ title: "underwater_medicine_and_hyperbaric_medicine"},
		{ title: "emergency_medicine"},
		{ title: "forensic_medicine"},
		{ title: "public_health"},
		{ title: "physiology"},
		{ title: "family_medicine"},
		{ title: "anatomy"},
		{ title: "embryology_and_histology"}
	],
};